// Persistent per-installation id used for the entry-code identity lock.
// Stored in localStorage so it survives reloads but is unique per device/browser.

const KEY = "rg_device_id";

export function getDeviceId(): string {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id =
      globalThis.crypto?.randomUUID?.() ??
      `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}
